import { usePortalAuth, AppRole } from './usePortalAuth';

export function useRole() {
  const { roles, isSuperAdmin, isAdmin, isTeam, isClient, isLoading } = usePortalAuth();

  const hasRole = (role: AppRole): boolean => {
    return roles.includes(role);
  };

  const hasAnyRole = (checkRoles: AppRole[]): boolean => {
    return checkRoles.some(role => roles.includes(role));
  };

  // Check if user can access admin-only features
  const canManageUsers = isAdmin;
  const canManageOrganizations = isAdmin;
  const canManageRoles = isAdmin;

  // Check if user can manage content (admin or team)
  const canUploadReports = isAdmin || isTeam;
  const canManageProjects = isAdmin || isTeam;
  const canManageInvoices = isAdmin || isTeam;
  const canUploadFiles = isAdmin || isTeam;

  // All authenticated users can do these
  const canViewReports = true;
  const canViewInvoices = true;
  const canViewProjects = true;
  const canViewFiles = true;
  const canCreateTickets = true;
  const canManageTickets = isAdmin || isTeam;

  return {
    roles,
    isSuperAdmin,
    isAdmin,
    isTeam,
    isClient,
    isLoading,
    hasRole,
    hasAnyRole,
    canManageUsers,
    canManageOrganizations,
    canManageRoles,
    canUploadReports,
    canManageProjects,
    canManageInvoices,
    canUploadFiles,
    canViewReports,
    canViewInvoices,
    canViewProjects,
    canViewFiles,
    canCreateTickets,
    canManageTickets,
  };
}
